export const TASK_STATUS = {
  ACTIVE: { name: 'Ожидает', value: 1 },
  CHECKING: { name: 'На проверке', value: 2 },
  NOT_DONE: { name: 'Не выполнено', value: 3 },
  DONE: { name: 'Выполнено', value: 4 },
};
